import { addDummySignals } from '../addDummySignals';
import { signalsToSpinSystem } from '../simulation/signalsToSpinSystem';
import { simulateXYPeaks } from '../simulation/simulateXYPeaks';
import { splitSpinSystem } from '../simulation/splitSpinSystem';
export function signalsToPointXY(signals, options) {
    const { frequency, maxClusterSize = 1 } = options;
    const completeSignalSet = addDummySignals(signals);
    const spinSystem = signalsToSpinSystem(completeSignalSet);
    spinSystem.clusters = splitSpinSystem(spinSystem, {
        frequency,
        maxClusterSize,
    });
    const pointsXY = simulateXYPeaks(spinSystem, options).filter((point) => point.x < 1000);
    const maxIntensity = pointsXY.reduce((max, peak) => (peak.y > max ? peak.y : max), Number.MIN_SAFE_INTEGER);
    for (const point of pointsXY) {
        point.y /= maxIntensity;
    }
    return pointsXY;
}
//# sourceMappingURL=signalsToPointXY.js.map